import { curry, overSome, isNumber, find } from 'lodash/fp';
import { createStructuredSelector } from 'reselect';
import { getNormalizedContentIdentifiersForContent } from './helpers';

export const isAssignedDirectly = content => content.context.assignedDirectly;

export const isInLibraryDirectly = content => content.context.inLibraryDirectly;

export const isAvailableDirectly = overSome([
  isAssignedDirectly,
  isInLibraryDirectly,
]);

export const isInCollection = curry((collection, content) => {
  const { id, type } = getNormalizedContentIdentifiersForContent(content);
  return !!find({ id, type }, collection);
});

export const isCompleted = ({ progress }) => !!progress.completedDate;

export const isStarted = content => !!content.progress.startDate;

export const isOverdue = ({ progress }) => progress.isOverdue;

export const isIncomplete = ({ progress }) =>
  progress.startDate && !progress.completedDate;

export const isFeatured = content =>
  content.isFeatured && isAvailableDirectly(content);

export const hasScore = ({ progress }) => isNumber(progress.score);

export const getComputedProps = createStructuredSelector({
  isOverdue,
  isCompleted,
  isIncomplete,
  hasScore,
});
